export default "__VITE_ASSET__cd97b84f__"